import Config from 'Config';
import Service from './Service';
import { ApplicationDocument } from 'client-experience-toolbox';

export class FileService extends Service {
  constructor() {
    super(Config.fileServiceUrl);
  }

  public async deleteFileFromS3(fileName: string): Promise<ApplicationDocument> {
    const response = await this.axios.delete(`/v3/onboarding/${fileName}`);
    if (response.status !== 200) {
      throw new Error(`Failed to fetch application data: ${response.statusText}`);
    }
    return response.data as ApplicationDocument;
  }
}
